import { render } from "./ProjectBase.vue?vue&type=template&id=45bc47fc&scoped=true"
import script from "./ProjectBase.vue?vue&type=script&lang=js"
export * from "./ProjectBase.vue?vue&type=script&lang=js"

import "./ProjectBase.vue?vue&type=style&index=0&id=45bc47fc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bc47fc"]])

export default __exports__